<template>
  <div>
    <div class="form-group row mb-2">
      <label class="col-sm-4 lh30 text-lr">
        <i v-if=" Data.data.c_priority==='S'" class="fa fa-asterisk text-danger font10 ml-1"
           aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 "  v-for="(item,index) in temp_list" :key="index">
        <el-input-number v-model="value" @change="dealData" :min="Data.data.c_data_type==='Numf'?-Infinity:0"
                         size="small" label="描述文字"></el-input-number>
        <span style="margin-left: 5px">  <el-button type="text" @click="add_temp()">+</el-button>
         <el-button type="text" @click="min_temp(index)" v-if="temp_list.length>1">-</el-button></span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "input-number",
  props: [
    'Data'
  ],
  data() {
    return {
      value: this.Data.data.c_value,
      temp_list:[{'value':''}]

    }
  },
  created() {
  },
  watch: {},
  methods: {
    dealData(){
      var arry=[]
      for(let i in this.temp_list){
        arry.push(this.temp_list[i].value)
      }
      this.$get_function(this.Data,arry)

    },
    min_temp(index){
      this.temp_list.splice(index,1)
    },
    add_temp(){
      this.temp_list.push({'value':''})
    },
  }


}
</script>

<style scoped>

</style>
